import { useLayoutEffect } from 'react';

const PRELOADER_ID = 'preloader';

const getPreloaderElement = () => document.getElementById(PRELOADER_ID);

export const hideLoader = () => {
  const element = getPreloaderElement();
  if (!element) return;

  element.classList.add('fade');

  const hideTimeout = setTimeout(() => {
    element.classList.add('hide');
    element.classList.remove('animate');
    clearTimeout(hideTimeout);
  }, 1000);
};

export const showLoader = () => {
  const element = getPreloaderElement();
  if (!element) return;

  element.classList.remove('fade', 'hide');
  element.classList.add('animate');
};

export const useInitVivicaLoader = (ready: boolean) => {
  useLayoutEffect(() => {
    if (ready) {
      hideLoader();
    } else {
      showLoader();
    }
  }, [ready]);
};
